import React from "react";
import { toast } from "sonner";
import { Copy, Download, ExternalLink } from "lucide-react";
import { api } from "../../lib/api";

const OPEN_AT = {
  Instagram: "https://www.instagram.com/",
  Facebook: "https://www.facebook.com/",
  LinkedIn: "https://www.linkedin.com/feed/",
  TikTok: "https://www.tiktok.com/upload",
};

/** Everything a customer needs to post an approved item by hand, in three taps. */
export const ManualPostActions = ({ item }) => {
  const copyAll = () => {
    const text = [item.caption, item.hashtags].filter(Boolean).join("\n\n");
    navigator.clipboard?.writeText(text);
    toast.success("Caption copied — paste it into " + item.platform + ".");
  };

  const downloadPhoto = async () => {
    try {
      const { data } = await api.get(`/media/${item.media_id}`);
      const a = document.createElement("a");
      a.href = data.data_url;
      a.download = data.filename || "postmint-image";
      a.click();
      toast.success("Photo downloaded.");
    } catch (e) {
      toast.error("We couldn't download that photo.");
      console.error(e);
    }
  };

  const btn =
    "inline-flex items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-800 transition-colors hover:bg-slate-50";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`manual-post-actions-${item.id}`}>
      <button type="button" onClick={copyAll} className={btn} data-testid={`manual-copy-${item.id}`}>
        <Copy className="h-3.5 w-3.5" aria-hidden="true" /> Copy caption
      </button>
      {item.media_id && (
        <button type="button" onClick={downloadPhoto} className={btn} data-testid={`manual-download-${item.id}`}>
          <Download className="h-3.5 w-3.5" aria-hidden="true" /> Download photo
        </button>
      )}
      <a
        href={OPEN_AT[item.platform] || "https://www.instagram.com/"}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
        data-testid={`manual-open-${item.id}`}
      >
        <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" /> Open {item.platform}
      </a>
    </div>
  );
};

export default ManualPostActions;
